module.exports = __webpack_public_path__ + "img/8.6db02f6c.jpeg";